import _ from 'lodash';
// eslint-disable-next-line object-curly-newline
const ProductsConfig = {
	initialState: {
		fields: {
			name: '',
			description: '',
			brand: null,
			categoryImage: '',
			code: '',
		},
		errors: {
			name: '',
			description: '',
			brand: '',
			categoryImage: '',
			code: '',
		},
	},
	mandatoryFields: {
		name: true,
		description: true,
		brand: true,
		categoryImage: false,
		code: false,
	},
	serializer: (state, data) => {
		return _.update(_.cloneDeep(state), 'fields', () => {
			const newState = {
				name: data.productCategoryName,
				description: data.productCategoryDescription,
				brand: data.brandId,
				categoryImage: data.productCategoryImage,
				code: data.productCategoryCode ?? '',
			};
			return newState;
		});
	},
	deserializer: (state) => {
		const newState = {
			productCategoryName: state.fields.name,
			productCategoryDescription: state.fields.description,
			brandId: state.fields.brand,
			productCategoryImage: state.fields.categoryImage,
			categoryCode: state.fields.code,
		};
		return newState;
	},
};
export default ProductsConfig;
